import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND } from '../lib/brand';

export default function BrandLogo({ compact = false, className = '', textClassName = '', imageClassName = '' }) {
  if (compact) {
    return (
      <Link to="/" className={`flex items-center group ${className}`.trim()} data-testid="brand-logo-link">
        <img
          src={BRAND.logoUrl}
          alt={`${BRAND.name} full logo`}
          className={`h-16 w-auto max-w-[18rem] object-contain opacity-100 transition-transform duration-500 group-hover:scale-[1.02] ${imageClassName}`.trim()}
        />
      </Link>
    );
  }

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`.trim()} data-testid="brand-logo-link">
      <div className={`relative overflow-hidden ${compact ? 'h-10 w-10' : 'h-12 w-12'} ${imageClassName}`.trim()}>
        <img
          src={BRAND.logoUrl}
          alt={`${BRAND.name} logo`}
          className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0">
        <p className={`font-bold tracking-tight text-slate-950 transition-colors duration-300 group-hover:text-violet-700 ${compact ? 'text-base' : 'text-lg'} ${textClassName}`.trim()}>
          {BRAND.name}
        </p>
        {!compact && (
          <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-slate-500">
            Public Health, Explained Simply
          </p>
        )}
      </div>
    </Link>
  );
}
